export const NTA_COLORS = {
  white: '#FFFFFF',
  textPrimary: '#3C4852',
  textSecondary: '#6C6C6C',
  textMuted: '#555555',
  accentBlue: '#2D81F7',
  noteText: '#9F878B',
  divider: '#E9EEF2',
  proceed: '#007ABB',
  timerPill: '#008FC6',
  checkboxBg: '#E4E2E3',
  checkboxBorder: '#DAD8D8',
  error: '#E74C3C',
  avatarBorder: '#555555',
  headerGradientStart: '#1A4C91',
  headerGradientMid: '#2468C7',
  headerGradientEnd: '#2D81F7',
  topBarShadow: '#F0F4F7',
  actionSaveNext: '#3FA951',
  actionSaveMark: '#F1AD4E',
  actionMarkNext: '#337AB7',
  actionSubmit: '#3FA951',
  actionNavText: '#7A8B94',
  questionText: '#313131',
  questionBorder: '#8F8F8F',
  optionControlBg: '#F7F7F7',
  optionControlBorder: '#C2C2C2',
  optionControlMark: '#313131',
  calculatorBorder: '#959494',
  calculatorBg: '#F0F0F0',
  calculatorIcon: '#575757',
  numberPadKeyBg: '#F8F9F9',
  numberPadKeyBorder: '#D6D6D6',
  paletteLabel: '#676767',
  paletteCollapseBg: '#000000',
  footerBg: '#F5F5F5',
  footerBorder: '#F2F2F2',
  scrollTrack: '#F1F1F1',
  scrollThumb: '#C2C2C2',
  scrollArrow: '#5D5D5D',
  paletteNotVisitedStart: '#F4F5F4',
  paletteNotVisitedEnd: '#E0E0E0',
  paletteNotVisitedBorder: '#959494',
  paletteNotAnswered: '#EB5757',
  paletteAnswered: '#08BD80',
  paletteMarked: '#7260E0',
  tableBorder: '#DDDDDD',
  tableCellText: '#8A8A8A',
  confirmButtonBorder: '#DEDEDE',
  resultDivider: '#E9EEF2',
  resultLabel: '#7A8B94',
  resultBack: '#1ABEE4',
  statusWrong: '#E53E3E',
  statusCorrect: '#08BD80',
  warningTitle: '#555454',
  warningMessage: '#8C8C8C',
  warningButton: '#007BC8',
  warningOverlay: 'rgba(108, 108, 108, 0.61)'
};

export const NTA_SUBMIT_STEP = {
  CONFIRM: 'confirm',
  SUCCESS: 'success',
  RESULT: 'result'
};

export const NTA_FONT_AVERTA =
  'AvertaStd, -apple-system, BlinkMacSystemFont, sans-serif';

/** @deprecated use NTA_FONT_AVERTA */
export const NTA_FONT_UI = NTA_FONT_AVERTA;

export const NTA_PAGE_MAX_WIDTH = '1366px';
export const NTA_PAGE_PADDING_X = '48px';

export const NTA_HEADER_VARIANT = {
  INSTRUCTIONS: 'instructions',
  TEST: 'test'
};

export const NTA_HEADER_TITLES = {
  GENERAL_INSTRUCTIONS: 'General Instructions'
};

export const NTA_INSTRUCTIONS_INTRO = 'Please read the instructions carefully';

export const NTA_LANGUAGE_NOTE =
  'Please note all questions will appear in your default language. This language can be changed for a particular question later on.';

export const NTA_TNC_TEXT =
  'I have read and understood the instructions. All computer hardware allotted to me are in proper working condition. I declare that I am not in possession of / not wearing / not carrying any prohibited gadget like mobile phone, bluetooth devices etc. /any prohibited material with me into the Examination Hall. I agree that in case of not adhering to the instructions, I shall be liable to be debarred from this Test and/or to disciplinary action, which may include ban from future Tests / Examinations';

export const NTA_ALERTS = {
  CHOOSE_OPTION: 'Please choose an option',
  ACCEPT_DECLARATION: 'Please accept terms and conditions before proceeding!',
  WARNING_TITLE: 'Warning!'
};

export const NTA_SIDEBAR_WIDTH = '340px';
export const NTA_SIDEBAR_WIDTH_COMPACT = '200px';

export const SCROLL_NAV_RIGHT_OFFSET = 26;
